import { disputeSource } from "@redotech/redo-model/disputes/dispute-definition";
import * as z from "zod/v4";

export const submitDisputeEvidence = {
  name: "submitDisputeEvidence" as const,
  input: z.object({ disputeId: z.string(), source: z.enum(disputeSource) }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
